import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Faq from '../../../../public/Icons/question_info.svg';

const ToolTipContent = ({ label, isBottom }) => {
    return (
        <>
            <OverlayTrigger placement={isBottom ? "bottom" : "top"} overlay={<Popover className='imageUploadTooltipContainer'>{label}</Popover>}>
                <img src={Faq} />
            </OverlayTrigger>
        </>
    )
}

export default ToolTipContent;
